<template>
  <div>
    <Breadcrumb v-if="backofficeRole === 'admin'" origin-name="Standorte" origin-path="/locations" :current-name="this.fixName || 'Neuen Standort anlegen'" />
    <h3 v-if="isNewLocation">Neuen Standort anlegen</h3>
    <h3 v-else>Standort bearbeiten</h3>
    <form @submit.prevent="submit">
      <div class="form-group">
        <label for="name-input">Name*</label>
        <input autofocus
               type="text"
               class="form-control"
               id="name-input"
               placeholder="Name"
               v-model="name"
               required />
      </div>
      <div class="form-group">
        <label for="description-input">Beschreibung</label>
        <textarea class="form-control"
                  id="description-input"
                  placeholder="Beschreibung"
                  v-model="description"></textarea>
      </div>
      <div class="form-group">
        <label for="address-input">Adresse</label>
        <textarea class="form-control"
                  id="address-input"
                  placeholder="Adresse"
                  v-model="address"></textarea>
      </div>
      <div class="form-group">
        <label for="phone-input">Telefonnummer</label>
        <textarea class="form-control"
                  id="phone-input"
                  placeholder="Telefonnummer"
                  v-model="phone"></textarea>
      </div>
      <div class="form-group">
        <label for="comment-input">Kommentar</label>
        <textarea class="form-control"
                  id="comment-input"
                  placeholder="Kommentar"
                  v-model="comment"></textarea>
      </div>
      <div class="form-group">
        <label for="paymentInfo-input">Zahlungsinformation</label>
        <textarea class="form-control"
                  id="paymentInfo-input"
                  placeholder="Zahlungsinformation"
                  v-model="paymentInfo"></textarea>
      </div>
      <div v-if="createdAt">Erstellt am {{ createdAt | dateFormat }}</div>
      <div class="hint mb-3">* Pflichtfeld</div>
      <button class="btn btn-primary" :class="{disabled: loading}">
        {{ isNewLocation ? "Anlegen" : "Speichern" }}
        <span v-if="loading" class="spinner"></span>
      </button>
      <button @click.prevent="toggleDialogVisible = true" v-if="!isNewLocation && backofficeRole === 'admin'" class="btn btn-danger delete-button" :class="{disabled: loading}">
        {{ active ? "Deaktivieren" : "Aktivieren" }}
        <span v-if="loading" class="spinner"></span>
      </button>
    </form>
    <Dialog :visible="toggleDialogVisible"
            :title="active ? 'Deaktivieren?' : 'Aktivieren?'"
            :ok-button-text="`Ja, ${active ? 'deaktivieren' : 'aktivieren'}!`"
            @cancel="toggleDialogVisible = false"
            @ok="toggleLocation"
            :message="`Wollen Sie die Standort ${active ? 'deaktivieren' : 'aktivieren'}?`">
    </Dialog>
  </div>
</template>

<script>
import {communicator} from "@/util/communicator.js";
import {broadcast} from "@/util/eventHandler.js";
import Dialog from "@/components/partial/Dialog.vue";
import Breadcrumb from "@/components/partial/Breadcrumb.vue";
import {getBackofficeRole} from "@/util/authenticator";

export default {
  components: {Breadcrumb, Dialog},
  name: "LocationEditor",
  data() {
    return {
      backofficeRole: "",
      fixName: "",
      name: "",
      description: "",
      address: "",
      phone: "",
      comment: "",
      paymentInfo: "",
      createdAt: "",
      locationId: undefined,
      active: false,
      loading: false,
      deleteDialogVisible: false,
      toggleDialogVisible: false,
      isNewLocation: false
    };
  },
  created() {
    if(this.$route.params.id) {
      const location = this.$store.state.locations.find(e => String(e.id) === this.$route.params.id);
      this.mapLocation(location);
    }
    else this.isNewLocation = true;
    this.backofficeRole = getBackofficeRole();
  },
  methods: {
    mapLocation(location) {
      this.fixName = location.name || "";
      this.name = location.name || "";
      this.description = location.description || "";
      this.address = location.address || "";
      this.phone = location.phone || "";
      this.comment = location.comment || "";
      this.paymentInfo = location.paymentInfo || "";
      this.createdAt = location.createdAt || "";
      this.locationId = location.id;
      this.active = location.active || false;
    },
    async submit() {
      if(this.loading) return;
      try {
        this.loading = true;
        const data = {
          id: this.locationId,
          name: this.name,
          description: this.description,
          address: this.address,
          phone: this.phone,
          comment: this.comment,
          paymentInfo: this.paymentInfo
        };
        if(this.locationId) {
          data.id = this.locationId;
        }
        const response = await communicator[this.isNewLocation ? "post" : "put"]("/locations", data);
        if(this.isNewLocation) this.$router.push("/locations");
        else {
          this.fixName = this.name;
          broadcast("tab-changed");
        }
        console.log("[AddLocation] Got response: ", response);
      } catch (e) {
        broadcast("error", e.response.data);
      }
      this.loading = false;
    },

    openDeleteDialog() {
      this.deleteDialogVisible = true;
    },

    async toggleLocation() {
      console.log("Disable: ", this.location);
      if(this.loading) return;
      this.loading = true;
      this.toggleDialogVisible = false;
      try {
        await communicator.put("/locations/", {
          id: this.locationId,
          name: this.name,
          active: !this.active
        });
        this.$router.push("/locations");
      } catch (e) {
        broadcast("error", e.response.data);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.delete-button {
  margin-left: 1rem;
  display: inline-block;
}
</style>
